import Assessment, { IAssessmentSnapshotIn } from "./Assessment";

export const LegalAssessmentQuestionsSnapshot = [
  {
    key: "LegalDomainTask1",
    timeToComplete: null,
    question:
      "Have you encouraged your parent to consult with an elder law Attorney to be sure legal documents represent their wishes?",
    answer: "",
    resource: "blank",
    taskName: "Legal Documents",
  },
  {
    key: "LegalDomainTask2",
    timeToComplete: null,
    question:
      "Have you helped your loved one establish a budgetary plan that takes into account all their assets, liabilities, income sources, life insurance policies, and other benefits to which they are entitled?",
    answer: "",
    resource: "blank",
    taskName: "Budget Plan",
  },
  {
    key: "LegalDomainTask3",
    timeToComplete: null,
    question:
      "Have you worked with the older adult to learn about all the benefits that may be available to them?",
    answer: "",
    resource: "blank",
    taskName: "Exploring Benefits",
  },
  {
    key: "LegalDomainTask4",
    timeToComplete: null,
    question:
      "Have you and your older adult discussed potential options and costs of long-term care?",
    answer: "",
    resource: "blank",
    taskName: "Long-Term Care Planning",
  },
  {
    key: "LegalDomainTask5",
    timeToComplete: null,
    question:
      "Have you helped the older adult organize financial and legal documents and place them in an accessible, fire safe and secure location?",
    answer: "",
    resource: "blank",
    taskName: "Organizing Documents",
  },
  {
    key: "LegalDomainTask6",
    timeToComplete: null,
    question:
      "Have you helped the older adult review the legal ownership status of real property and other titled property to ensure that both current and future ownership and control of this property is in accord with their wishes?",
    answer: "",
    resource: "blank",
    taskName: "Property Review",
  },
  {
    key: "LegalDomainTask7",
    timeToComplete: null,
    question:
      "Have you helped the older adult identify family valuables and put in writing their wishes about who will inherit each family heirloom?",
    answer: "",
    resource: "blank",
    taskName: "Family Heirlooms",
  },
  {
    key: "LegalDomainTask8",
    timeToComplete: null,
    question:
      "Have you worked with the older adult to provide for the needs of any disabled family members for whom they provide care and/or funds should the older adult die or become disabled?",
    answer: "",
    resource: "blank",
    taskName: "Care of Dependents",
  },
  {
    key: "LegalDomainTask9",
    timeToComplete: null,
    question:
      "Have you and the older adult reviewed information about how to prevent fraud, scams, and identity theft? ",
    answer: "",
    resource: "blank",
    taskName: "Preventing Fraud",
  },
];

export const LegalAssessmentSnapshot: IAssessmentSnapshotIn = {
  id: "Legal",
  questions: LegalAssessmentQuestionsSnapshot,
  infoSlideKeys: [
    "LegalDomainTask1",
    "LegalDomainTask2",
    "LegalDomainTask3",
    "LegalDomainTask4",
    "LegalDomainTask5",
    "LegalDomainTask6",
    "LegalDomainTask7",
    "LegalDomainTask8",
    "LegalDomainTask9",
  ],
};

export const DefaultLegalAssessment = Assessment.create(
  LegalAssessmentSnapshot
);
